/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { BackupCodesResponse } from '../model/backupCodesResponse';
// @ts-ignore
import { DeleteSecurityKeyRequest } from '../model/deleteSecurityKeyRequest';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { MfaDisableRequest } from '../model/mfaDisableRequest';
// @ts-ignore
import { MfaEnrollRequest } from '../model/mfaEnrollRequest';
// @ts-ignore
import { MfaEnrollResponse } from '../model/mfaEnrollResponse';
// @ts-ignore
import { MfaStatusResponse } from '../model/mfaStatusResponse';
// @ts-ignore
import { MfaStepUpRequest } from '../model/mfaStepUpRequest';
// @ts-ignore
import { MfaStepUpResponse } from '../model/mfaStepUpResponse';
// @ts-ignore
import { MfaSuccessResponse } from '../model/mfaSuccessResponse';
// @ts-ignore
import { MfaVerifyEnrollRequest } from '../model/mfaVerifyEnrollRequest';
// @ts-ignore
import { MfaVerifyRequest } from '../model/mfaVerifyRequest';
// @ts-ignore
import { MfaVerifyResponse } from '../model/mfaVerifyResponse';
// @ts-ignore
import { RegenerateBackupCodesRequest } from '../model/regenerateBackupCodesRequest';
// @ts-ignore
import { RenameSecurityKeyRequest } from '../model/renameSecurityKeyRequest';
// @ts-ignore
import { SecurityKeyAssertionRequest } from '../model/securityKeyAssertionRequest';
// @ts-ignore
import { SecurityKeyListResponse } from '../model/securityKeyListResponse';
// @ts-ignore
import { SecurityKeyMutationResponse } from '../model/securityKeyMutationResponse';
// @ts-ignore
import { SecurityKeyRegistrationOptionsRequest } from '../model/securityKeyRegistrationOptionsRequest';
// @ts-ignore
import { SecurityKeyRegistrationResponse } from '../model/securityKeyRegistrationResponse';
// @ts-ignore
import { SecurityKeyRegistrationVerifyRequest } from '../model/securityKeyRegistrationVerifyRequest';
// @ts-ignore
import { SecurityKeyStepUpResponse } from '../model/securityKeyStepUpResponse';
// @ts-ignore
import { SecurityKeySummary } from '../model/securityKeySummary';
// @ts-ignore
import { WebauthnChallengeResponse } from '../model/webauthnChallengeResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    MfaApiServiceInterface
} from './mfa.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class MfaApiService extends BaseService implements MfaApiServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Begin registration for a roaming FIDO2 security key.
     * @endpoint post /api/v1/security/security-keys/registration/options
     * @param securityKeyRegistrationOptionsRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public beginRegistration(securityKeyRegistrationOptionsRequest: SecurityKeyRegistrationOptionsRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<WebauthnChallengeResponse>;
    public beginRegistration(securityKeyRegistrationOptionsRequest: SecurityKeyRegistrationOptionsRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<WebauthnChallengeResponse>>;
    public beginRegistration(securityKeyRegistrationOptionsRequest: SecurityKeyRegistrationOptionsRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<WebauthnChallengeResponse>>;
    public beginRegistration(securityKeyRegistrationOptionsRequest: SecurityKeyRegistrationOptionsRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (securityKeyRegistrationOptionsRequest === null || securityKeyRegistrationOptionsRequest === undefined) {
            throw new Error('Required parameter securityKeyRegistrationOptionsRequest was null or undefined when calling beginRegistration.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/security/security-keys/registration/options`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WebauthnChallengeResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: securityKeyRegistrationOptionsRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Begin a session-bound security-key MFA step-up.
     * @endpoint post /api/v1/auth/mfa/security-key/step-up/options
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public beginStepUp(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<WebauthnChallengeResponse>;
    public beginStepUp(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<WebauthnChallengeResponse>>;
    public beginStepUp(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<WebauthnChallengeResponse>>;
    public beginStepUp(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/security-key/step-up/options`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WebauthnChallengeResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete all enrolled security keys.
     * @endpoint delete /api/v1/security/security-keys
     * @param deleteSecurityKeyRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAllSecurityKeys(deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SecurityKeyMutationResponse>;
    public deleteAllSecurityKeys(deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SecurityKeyMutationResponse>>;
    public deleteAllSecurityKeys(deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SecurityKeyMutationResponse>>;
    public deleteAllSecurityKeys(deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (deleteSecurityKeyRequest === null || deleteSecurityKeyRequest === undefined) {
            throw new Error('Required parameter deleteSecurityKeyRequest was null or undefined when calling deleteAllSecurityKeys.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/security/security-keys`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SecurityKeyMutationResponse>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: deleteSecurityKeyRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete one enrolled security key.
     * @endpoint delete /api/v1/security/security-keys/{key_id}
     * @param keyId Opaque security-key record ID
     * @param deleteSecurityKeyRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSecurityKey(keyId: string, deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SecurityKeyMutationResponse>;
    public deleteSecurityKey(keyId: string, deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SecurityKeyMutationResponse>>;
    public deleteSecurityKey(keyId: string, deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SecurityKeyMutationResponse>>;
    public deleteSecurityKey(keyId: string, deleteSecurityKeyRequest: DeleteSecurityKeyRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (keyId === null || keyId === undefined) {
            throw new Error('Required parameter keyId was null or undefined when calling deleteSecurityKey.');
        }
        if (deleteSecurityKeyRequest === null || deleteSecurityKeyRequest === undefined) {
            throw new Error('Required parameter deleteSecurityKeyRequest was null or undefined when calling deleteSecurityKey.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/security/security-keys/${this.configuration.encodeParam({name: "keyId", value: keyId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SecurityKeyMutationResponse>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: deleteSecurityKeyRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Disable MFA for the authenticated user
     * Requires password verification and a valid TOTP code to prevent unauthorized disabling of MFA.
     * @endpoint delete /api/v1/auth/mfa/disable
     * @param mfaDisableRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disableMfa(mfaDisableRequest: MfaDisableRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MfaSuccessResponse>;
    public disableMfa(mfaDisableRequest: MfaDisableRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MfaSuccessResponse>>;
    public disableMfa(mfaDisableRequest: MfaDisableRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MfaSuccessResponse>>;
    public disableMfa(mfaDisableRequest: MfaDisableRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mfaDisableRequest === null || mfaDisableRequest === undefined) {
            throw new Error('Required parameter mfaDisableRequest was null or undefined when calling disableMfa.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/disable`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MfaSuccessResponse>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mfaDisableRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finish a security-key registration ceremony.
     * @endpoint post /api/v1/security/security-keys/registration/verify
     * @param securityKeyRegistrationVerifyRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public finishRegistration(securityKeyRegistrationVerifyRequest: SecurityKeyRegistrationVerifyRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SecurityKeyRegistrationResponse>;
    public finishRegistration(securityKeyRegistrationVerifyRequest: SecurityKeyRegistrationVerifyRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SecurityKeyRegistrationResponse>>;
    public finishRegistration(securityKeyRegistrationVerifyRequest: SecurityKeyRegistrationVerifyRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SecurityKeyRegistrationResponse>>;
    public finishRegistration(securityKeyRegistrationVerifyRequest: SecurityKeyRegistrationVerifyRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (securityKeyRegistrationVerifyRequest === null || securityKeyRegistrationVerifyRequest === undefined) {
            throw new Error('Required parameter securityKeyRegistrationVerifyRequest was null or undefined when calling finishRegistration.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/security/security-keys/registration/verify`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SecurityKeyRegistrationResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: securityKeyRegistrationVerifyRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Finish a session-bound security-key MFA step-up.
     * @endpoint post /api/v1/auth/mfa/security-key/step-up/verify
     * @param securityKeyAssertionRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public finishStepUp(securityKeyAssertionRequest: SecurityKeyAssertionRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SecurityKeyStepUpResponse>;
    public finishStepUp(securityKeyAssertionRequest: SecurityKeyAssertionRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SecurityKeyStepUpResponse>>;
    public finishStepUp(securityKeyAssertionRequest: SecurityKeyAssertionRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SecurityKeyStepUpResponse>>;
    public finishStepUp(securityKeyAssertionRequest: SecurityKeyAssertionRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (securityKeyAssertionRequest === null || securityKeyAssertionRequest === undefined) {
            throw new Error('Required parameter securityKeyAssertionRequest was null or undefined when calling finishStepUp.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/security-key/step-up/verify`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SecurityKeyStepUpResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: securityKeyAssertionRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MFA status for the authenticated user
     * @endpoint get /api/v1/auth/mfa/status
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getStatus(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MfaStatusResponse>;
    public getStatus(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MfaStatusResponse>>;
    public getStatus(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MfaStatusResponse>>;
    public getStatus(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/status`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MfaStatusResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List the current user\&#39;s security keys without exposing credential material.
     * @endpoint get /api/v1/security/security-keys
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listSecurityKeys(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SecurityKeyListResponse>;
    public listSecurityKeys(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SecurityKeyListResponse>>;
    public listSecurityKeys(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SecurityKeyListResponse>>;
    public listSecurityKeys(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/security/security-keys`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SecurityKeyListResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Generate new backup codes
     * Generates a new set of backup codes, invalidating any existing codes. Should only be used when the user has lost access to their backup codes.
     * @endpoint post /api/v1/auth/mfa/backup-codes
     * @param regenerateBackupCodesRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regenerateBackupCodes(regenerateBackupCodesRequest: RegenerateBackupCodesRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<BackupCodesResponse>;
    public regenerateBackupCodes(regenerateBackupCodesRequest: RegenerateBackupCodesRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<BackupCodesResponse>>;
    public regenerateBackupCodes(regenerateBackupCodesRequest: RegenerateBackupCodesRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<BackupCodesResponse>>;
    public regenerateBackupCodes(regenerateBackupCodesRequest: RegenerateBackupCodesRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (regenerateBackupCodesRequest === null || regenerateBackupCodesRequest === undefined) {
            throw new Error('Required parameter regenerateBackupCodesRequest was null or undefined when calling regenerateBackupCodes.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/backup-codes`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<BackupCodesResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: regenerateBackupCodesRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Rename an enrolled security key.
     * @endpoint patch /api/v1/security/security-keys/{key_id}
     * @param keyId Opaque security-key record ID
     * @param renameSecurityKeyRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public renameSecurityKey(keyId: string, renameSecurityKeyRequest: RenameSecurityKeyRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SecurityKeySummary>;
    public renameSecurityKey(keyId: string, renameSecurityKeyRequest: RenameSecurityKeyRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SecurityKeySummary>>;
    public renameSecurityKey(keyId: string, renameSecurityKeyRequest: RenameSecurityKeyRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SecurityKeySummary>>;
    public renameSecurityKey(keyId: string, renameSecurityKeyRequest: RenameSecurityKeyRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (keyId === null || keyId === undefined) {
            throw new Error('Required parameter keyId was null or undefined when calling renameSecurityKey.');
        }
        if (renameSecurityKeyRequest === null || renameSecurityKeyRequest === undefined) {
            throw new Error('Required parameter renameSecurityKeyRequest was null or undefined when calling renameSecurityKey.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/security/security-keys/${this.configuration.encodeParam({name: "keyId", value: keyId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SecurityKeySummary>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: renameSecurityKeyRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Start MFA enrollment process
     * Generates a new TOTP secret and QR code for the user to scan with their authenticator app. The enrollment must be verified with a valid TOTP code before MFA is activated.
     * @endpoint post /api/v1/auth/mfa/enroll
     * @param mfaEnrollRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public startEnrollment(mfaEnrollRequest: MfaEnrollRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MfaEnrollResponse>;
    public startEnrollment(mfaEnrollRequest: MfaEnrollRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MfaEnrollResponse>>;
    public startEnrollment(mfaEnrollRequest: MfaEnrollRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MfaEnrollResponse>>;
    public startEnrollment(mfaEnrollRequest: MfaEnrollRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mfaEnrollRequest === null || mfaEnrollRequest === undefined) {
            throw new Error('Required parameter mfaEnrollRequest was null or undefined when calling startEnrollment.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/enroll`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MfaEnrollResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mfaEnrollRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * F6 MFA step-up: exchange a fresh MFA proof for a short-lived, session-bound step-up token.
     * Enter a code ONCE → receive an httpOnly+Secure+SameSite&#x3D;Strict cookie (&#x60;mfa_step_up&#x60;) bound to the current access session. The proof lasts up to 30 minutes, never beyond that session, and survives an access-token refresh of the same session. The admin MFA gate (&#x60;admin_mfa_layer&#x60;) accepts it for ordinary &#x60;/api/v1/admin/_*&#x60; reads for up to 30 minutes after verification; mutations, secret-bearing reads, and bulk exports require a verification within the last 5 minutes and otherwise answer &#x60;403 MFA_STEP_UP_REQUIRED&#x60;. This is an ALTERNATIVE to the raw &#x60;x-mfa-token&#x60; TOTP path (which remains intact); it solves the single-use-TOTP problem where one UI page firing several admin calls cannot reuse one code.  Accepts BOTH a 6-digit TOTP code and an 8-character backup code (parity with &#x60;/auth/mfa/verify&#x60;). The proof token is a SEPARATE &#x60;TokenType::StepUp&#x60; JWT — NOT the access token — so it can never be used as an ordinary API credential.
     * @endpoint post /api/v1/auth/mfa/step-up
     * @param mfaStepUpRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public stepUp(mfaStepUpRequest: MfaStepUpRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MfaStepUpResponse>;
    public stepUp(mfaStepUpRequest: MfaStepUpRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MfaStepUpResponse>>;
    public stepUp(mfaStepUpRequest: MfaStepUpRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MfaStepUpResponse>>;
    public stepUp(mfaStepUpRequest: MfaStepUpRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mfaStepUpRequest === null || mfaStepUpRequest === undefined) {
            throw new Error('Required parameter mfaStepUpRequest was null or undefined when calling stepUp.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/step-up`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MfaStepUpResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mfaStepUpRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verify MFA code (during login or sensitive operations)
     * Verifies a TOTP code or backup code. Used during login when MFA is enabled, or for sensitive operations that require additional authentication.
     * @endpoint post /api/v1/auth/mfa/verify
     * @param mfaVerifyRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public verifyCode(mfaVerifyRequest: MfaVerifyRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MfaVerifyResponse>;
    public verifyCode(mfaVerifyRequest: MfaVerifyRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MfaVerifyResponse>>;
    public verifyCode(mfaVerifyRequest: MfaVerifyRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MfaVerifyResponse>>;
    public verifyCode(mfaVerifyRequest: MfaVerifyRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mfaVerifyRequest === null || mfaVerifyRequest === undefined) {
            throw new Error('Required parameter mfaVerifyRequest was null or undefined when calling verifyCode.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/verify`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MfaVerifyResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mfaVerifyRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Verify MFA enrollment
     * Completes the MFA enrollment by verifying a TOTP code generated by the user\&#39;s authenticator app. Once verified, MFA will be required for future logins.
     * @endpoint post /api/v1/auth/mfa/enroll/verify
     * @param mfaVerifyEnrollRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public verifyEnrollment(mfaVerifyEnrollRequest: MfaVerifyEnrollRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<MfaSuccessResponse>;
    public verifyEnrollment(mfaVerifyEnrollRequest: MfaVerifyEnrollRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<MfaSuccessResponse>>;
    public verifyEnrollment(mfaVerifyEnrollRequest: MfaVerifyEnrollRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<MfaSuccessResponse>>;
    public verifyEnrollment(mfaVerifyEnrollRequest: MfaVerifyEnrollRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mfaVerifyEnrollRequest === null || mfaVerifyEnrollRequest === undefined) {
            throw new Error('Required parameter mfaVerifyEnrollRequest was null or undefined when calling verifyEnrollment.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer_auth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer_auth', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/auth/mfa/enroll/verify`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<MfaSuccessResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mfaVerifyEnrollRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
